// =====================================
//
//   product banner
//   Author: Gray
//   createtime: 2016 / 02 / 17
//   updatetime: 2016 / 02 / 17
//
// =====================================

window.InifECApp.directive('productBanner', ['$rootScope', function($rootScope) {

	var _dir = {};

	var link = function(scope, element, attrs) {

        var $banner = $(element).find('.carousel-wrapper');
        var $dot = $(element).find('.pdt-dot-content');

    	var init = function() {

            if(Array.isArray(scope.productBanner) && scope.productBanner.length > 0) {

                if(scope.productBanner.length > 1) {
                    bindDotCarousel();
                } else {
                    bindCarousel();
                }
            }
    	}

        var bindDotCarousel = function() {

            $dot.owlCarousel({
                items : 5,
                autoWidth: true,
                activeClass: 'showdot',
                nav: true,
                dots: true,
                dotsContainer : ".dot-dot-content",
                navContainerClass: 'pdt-dot-nav-content',
                navClass: ['nav-left','nav-right'],
                navText: ['<i class="zmdi zmdi-chevron-left"></i>', '<i class="zmdi zmdi-chevron-right"></i>']
            });

            bindCarousel();
        }

        var bindCarousel = function() {

            $banner.owlCarousel({
                items : 1,
                dots: true,
                dotsContainer: ".pdt-dot-content .owl-stage",
                dotData : true,
                nav: false,
                // navContainerClass: 'pdt-nav-content',
                // navClass: ['nav-left','nav-right'],
                // navText: ['<i class="zmdi zmdi-chevron-left"></i>', '<i class="zmdi zmdi-chevron-right"></i>']
                mouseDrag: false,
                touchDrag: false,
                pullDrag: false,
                freeDrag: false,
                smartSpeed: 0,
            });

            $banner.on('changed.owl.carousel', function(event) {
                $dot.trigger('to.owl.carousel', [event.item.index, 300]);
            })
        }

        scope.$watchCollection("productBanner", init);

    	//==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        // init();

	};

	_dir.restrict = 'A';
	_dir.scope = {
        productBanner: '='
    };
	_dir.link = link;

	return _dir;

}]);

window.InifECApp.directive('productDot', ['$rootScope', function($rootScope) {

    var _dir = {};

    var link = function(scope, element, attrs) {

        var init = function() {

            if(Array.isArray(scope.productDot) && scope.productDot.length > 0){
                bindCarousel();
            }
        }

        var bindCarousel = function() {

            $(element).owlCarousel({
                items : 5,
                autoWidth:true,
            });
        }

        scope.$watchCollection("productDot", init);

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        // init();

    };

    _dir.restrict = 'A';
    _dir.scope = {
        productDot: '='
    };
    _dir.link = link;

    return _dir;

}]);